import List from './List/List';

const ListProviderTransport = ({ data }) => {
  const columns = [
    { fieldname: 'nazivUsluge', label: 'Naziv usluge' },
    { fieldname: 'kolicina', label: 'Broj sati' },
    { fieldname: 'dobitZaposleniUsl', label: 'Iznos' },
  ];
  return (
    <div>
      <List
        listTitle="Transport"
        titleName="imeZaposlenog"
        columns={columns}
        data={data}
      />
    </div>
  );
};

export default ListProviderTransport;
